import * as React from 'react'
import { IStageProps, ISelection } from 'app/types'
import Clock from 'app/comp/clock'
import StageCounter from 'app/comp/stage-counter'
import Hint from 'app/comp/hint'
import Selectable from 'app/comp/selectable'
import { formatTime } from 'app/service/util'


export default class extends React.Component<IStageProps, {
  selection: ISelection
  hasSelected: boolean
}> {

  constructor(props) {
    super(props)

    this.state = {
      selection: undefined,
      hasSelected: false
    }
  }

  onChangeSelection = (selection: ISelection) => {
    const hasSelected = this.state.hasSelected || (!!selection && (selection[0] != selection[1]))

    this.setState({
      selection,
      hasSelected
    })
  }

  onClickClock = () => {
    const { time } = this.props

    const timeStr = formatTime(time)

    if (timeStr[timeStr.length - 1] == '1') {
      this.props.onNext()
    }
  }

  getText() {
    const {
      selection
    } = this.state

    const a = 'Select your path and find your destiny.'
    const b = 'When the clock strikes one strike back.'

    if (!selection) {
      return a
    }


    let text = ''

    const left = Math.min.apply(null, selection)
    const right = Math.max.apply(null, selection)

    for (let i = 0; i < left; i++) {
      text += a[i]
    }

    for (let i = left; i < right; i++) {
      text += b[i]
    }

    for (let i = right; i < a.length; i++) {
      text += a[i]
    }

    return text
  }

  getHintText(): string {
    const { hasSelected } = this.state

    if (hasSelected) {
      return "That clock just keeps clicking."
    } else {
      return "Select. Select. What can I select?"
    }
  }

  render() {
    return (
      <div>

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock
          time={this.props.time}
          onClick={this.onClickClock}
        />

        <Selectable
          text={this.getText()}
          selection={this.state.selection}
          onChangeSelection={this.onChangeSelection}
        />
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/select-clock.tsx